var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',{attrs:{"title":"Verify email"}},[(_vm.sharedState.loading)?_c('div',{staticClass:"list-group-item p-4"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }